<div class="surface-0">
  <div
    class="flex align-items-center justify-content-between flex-column h-screen"
  >
    <div
      class="flex flex-column align-items-center justify-content-center w-full md:w-4 h-full text-center py-6 px-4"
    >
      <a [routerLink]="['/']" class="mb-6" aria-label="Μετάβαση στην αρχική σελίδα">
        <!-- <img src="../../assets/layout/images/phi-logo.png" class="w-16rem"> -->
        <!-- <img
          src="../../assets/layout/images/phi_eurolife.png"
          class="w-10rem"
        /> -->
        <img
          src="../../assets/layout/images/phidelity_logo.png"
          alt="PHI"
          class="w-10rem"
        />
        <!-- <img
          src="../../assets/layout/images/phi_easfalistiki.png"
          class="w-10rem"
        /> -->
        
      </a>
      <!-- <div class="mb-4">
                <div class="text-900 text-xl font-bold mb-2">Register</div>
                <span class="text-600 font-medium">Let's get started</span>
            </div> -->
      <div class="flex flex-column">
        <span class="p-input-icon-left w-full mb-4">
          <i class="pi pi-user" aria-hidden="true"></i>
          <label for="username" class="sr-only">{{ 'REGISTER.USERNAME' | translate }}</label>
          <input
            id="username"
            type="text"
            autocomplete="username"
            pInputText
            class="w-full md:w-25rem text-color-secondary surface-50 border-200"
            placeholder="{{ 'REGISTER.USERNAME' | translate }}"
          />
        </span>
        <span class="p-input-icon-left w-full mb-4">
          <i class="pi pi-envelope" aria-hidden="true"></i>
          <label for="email" class="sr-only">Email</label>
          <input
            id="email"
            type="email"
            autocomplete="email"
            pInputText
            class="w-full md:w-25rem text-color-secondary surface-50 border-200"
            placeholder="Email"
          />
        </span>
        <span class="p-input-icon-left w-full mb-4">
          <i class="pi pi-lock" aria-hidden="true"></i>
          <!-- <p-password id="password" placeholder="{{ 'REGISTER.PASSWORD' | translate }}" [inputStyle]="{ paddingLeft: '2.5rem' }" inputStyleClass="w-full md:w-25rem text-color-secondary surface-50 border-200" [toggleMask]="true"></p-password> -->
          <label for="password" class="sr-only">{{ 'REGISTER.PASSWORD' | translate }}</label>
          <input
            id="password"
            type="password"
            autocomplete="new-password"
            pInputText
            class="w-full md:w-25rem text-color-secondary surface-50 border-200"
            placeholder="{{ 'REGISTER.PASSWORD' | translate }}"
          />
        </span>
        <div class="mb-4 flex flex-wrap">
          <p-checkbox
            name="checkbox"
            inputId="checkbox"
            value="val"
            [(ngModel)]="confirmed"
            styleClass="mr-2"
            [binary]="true"
          ></p-checkbox>
          <label for="checkbox" class="text-900 font-medium mr-2">{{
            "REGISTER.READ" | translate
          }}</label>
          <a
            class="text-600 cursor-pointer hover:text-primary cursor-pointer"
            href="#"
            >{{ "REGISTER.TERMS" | translate }}</a
          >
        </div>
        <button
          pButton
          pRipple
          label="{{ 'REGISTER.SIGNUP' | translate }}"
          class="w-full mb-4"
          [routerLink]="['/']"
        ></button>
        <span class="font-medium text-600"
          >{{ "REGISTER.ACCOUNT" | translate }}
          <a
            [routerLink]="['/login']"
            class="font-semibold cursor-pointer text-900 hover:text-primary transition-colors transition-duration-300"
            >{{ "REGISTER.LOGIN" | translate }}</a
          ></span
        >
      </div>
      <div class="mt-5">
        <button
          type="button"
          (click)="toggleDropdown()"
          style="border: none; background: transparent; cursor: pointer"
        >
          <img
            [src]="selectedLanguageIcon"
            alt="Selected Language"
            style="width: 20px; height: auto"
          />
        </button>
        @if(dropdownVisible){
        <div class="dropdown-menu" style="position: absolute; z-index: 1000">
          @for(lang of languages;track lang){
          <ng-container>
            <button
              type="button"
              (click)="switchLanguage(lang.value)"
              style="
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 0 0 5px 5px;
                background: none;
                border: none;
                width: 100%;
              "
            >
              <img
                [src]="lang.icon"
                alt="{{ lang.label }}"
                style="width: 15px; height: auto; margin-right: 5px"
              />
              {{ lang.label }}
            </button>
          </ng-container>
          }
        </div>
        }
      </div>
    </div>
    <div class="flex flex-wrap align-items-center pb-4 px-4">
      <h4 class="m-0 mr-5" style="line-height: 22px">PHI</h4>
      <!-- <h6 class="m-0 font-medium text-300" style="line-height: 17px">Copyright Ⓒ Covariance P.C.</h6> -->
    </div>
  </div>
</div>
